export default "__VITE_ASSET__DG5NBkMn__"